<template>
  <b-modal
    :id="id"
    ref="modal"
    hide-header
    hide-footer
    centered
    size="xl"
    body-class="p-0 overflow-hidden"
    content-class="border-0 shadow-lg"
    @shown="onShown"
  >
    <!-- Header -->
    <div class="modal-header-premium p-3 d-flex align-items-center bg-dark" style="background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%) !important;">
      <div class="header-icon-wrapper mr-3 bg-white-10">
        <i class="fa fa-list-alt text-white"></i>
      </div>
      <div>
        <h5 class="mb-0 font-weight-bold text-white">Localizar NFe Distribuída (XML)</h5>
        <small class="text-white opacity-75">Selecione uma nota da distribuição para conciliar com a devolução</small>
      </div>
      <b-button variant="link" class="ml-auto text-white p-0 opacity-75" @click="hide">
        <i class="fa fa-times fa-lg"></i>
      </b-button>
    </div> 

    <div class="p-4 bg-white">
      <!-- Search Filters -->
      <div class="search-bar-premium mb-4">
        <b-row align-v="end">
          <b-col md="5">
            <label class="small font-weight-bold text-muted">Documento / Chave</label>
            <b-form-input
              ref="inputSearch"
              v-model="filtro.documento"
              placeholder="Nº Nota ou Chave de Acesso..."
              class="custom-input-premium"
              @keydown.enter.native="pesquisar"
            />
          </b-col>
          <b-col md="5">
            <label class="small font-weight-bold text-muted">Emitente (Cliente/Fornecedor)</label>
            <b-form-input
              v-model="filtro.cliente"
              placeholder="Nome do emitente..."
              class="custom-input-premium"
              @keydown.enter.native="pesquisar"
            />
          </b-col>
          <b-col md="2">
            <b-button variant="primary" block class="font-weight-bold" @click="pesquisar" :disabled="isBusy">
              <i class="fa fa-search mr-2"></i> PESQUISAR
            </b-button>
          </b-col>
        </b-row>
      </div>


      <div class="d-flex justify-content-between align-items-center mb-2 px-1">
        <small class="text-muted font-italic">
          <i class="fa fa-info-circle mr-1"></i> Listando as últimas 500 notas da distribuição. Use os filtros para refinar.
        </small>
        <b-badge variant="soft-info" v-if="notas.length > 0">{{ notas.length }} registros encontrados</b-badge>
      </div>

      <!-- Results Table -->
      <div class="table-container shadow-xs rounded border overflow-hidden">
        <b-table
          hover
          small
          responsive
          show-empty
          empty-text="Nenhuma nota encontrada na distribuição"
          :items="notas"
          :fields="fields"
          :busy="isBusy"
          per-page="500"
          current-page="1"
          class="modern-premium-table mb-0"
          @row-clicked="selecionar"
        >
          <template #cell(VALOR)="data">
            {{ formatarMoeda(data.value) }}
          </template>
          <template #cell(DATA_NFE)="data">
            {{ formatarData(data.value) }}
          </template>
          <template #cell(VENDA_ID)="data">
            <b-badge v-if="data.value" variant="success">Venda #{{ data.value }}</b-badge>
            <span v-else class="text-muted small">Não vinculada</span>
          </template>
        </b-table>
      </div>
    </div>

    <div class="p-3 bg-light border-top d-flex justify-content-end">
      <b-button variant="secondary" pill class="px-4" @click="hide">Cancelar</b-button>
    </div>
  </b-modal>
</template>

<script>
import Tools from '@/tools/tools.js'

export default {
  name: 'PesquisaNfeDistribuicaoModal',
  props: {
    id: { type: String, default: 'modal-pesquisa-nfe-distribuicao' }
  },
  data() {
    return {
      isBusy: false,
      notas: [],
      filtro: {
        documento: '',
        cliente: ''
      },
      fields: [
        { key: 'ID', label: 'ID', sortable: true, width: '60px' },
        { key: 'TX_NUM_NFE', label: 'Nº Nota', sortable: true },
        { key: 'DATA_NFE', label: 'Emissão', sortable: true },
        { key: 'FORNECEDOR', label: 'Emitente', sortable: true },
        { key: 'VALOR', label: 'Valor', sortable: true, tdClass: 'text-right' },
        { key: 'QT_ITENS', label: 'Itens', sortable: true, tdClass: 'text-center' },
        { key: 'VENDA_ID', label: 'Venda Origem', sortable: true, tdClass: 'text-center' }
      ]
    }
  },
  methods: {
    formatarMoeda: Tools.formatCurrency,
    formatarData: Tools.formatarDataBR,
    onShown() {
      this.$refs.inputSearch.focus()
      this.pesquisar()
    },
    pesquisar() {
      this.isBusy = true
      this.$store.dispatch('devolucao/listarNfeDistribuicao', { filtro: this.filtro })
        .then(res => {
          this.notas = res
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    selecionar(item) {
      this.$emit('selecionado', item)
      this.hide()
    },
    hide() {
      this.$bvModal.hide(this.id)
    }
  }
}
</script>

<style scoped>
.header-icon-wrapper {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.15);
}

.custom-input-premium {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  height: 38px;
}

.table-container {
  max-height: 450px;
  overflow-y: auto;
}

.modern-premium-table >>> th {
  background: #f8fafc;
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  padding: 10px;
  border-top: none;
}

.modern-premium-table >>> td {
  padding: 10px;
  font-size: 13px;
  cursor: pointer;
}

.bg-white-10 {
  background: rgba(255, 255, 255, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/devolucao/PesquisaNfeDistribuicaoModal.vue